import { CompanyGroup } from 'app/modules/masters/company-group/models/company-group.model';

export interface CompanyGroupState {
  companyGroups: CompanyGroup[];
  total: number;
  loading: boolean;
  error: string | null;
  searchResults: CompanyGroup[]
}

export const initialCompanyGroupState: CompanyGroupState = {
  companyGroups: [],
  total: 0,
  loading: false,
  error: null,
  searchResults: [] 
};
